import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/box.png'
import _imports_1 from '../images/about-ripple.png'
import _imports_2 from '../images/tab4-banner-1.png'
import _imports_3 from '../images/tab4-banner-2.png'
import _imports_4 from '../images/tab4-banner-3.png'
import _imports_5 from '../images/tab4-banner-4.png'


const _withScopeId = n => (_pushScopeId("data-v-5da1bcbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "box-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "box-icon"
}, null, -1))
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "wave-icon"
}, null, -1))
const _hoisted_6 = { class: "mian-container" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 해양환경 보전 교육 ", -1))
const _hoisted_8 = { class: "board" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"board-title\" data-v-5da1bcbc> 온라인 </div><div class=\"board-desc d-none d-sm-block\" data-v-5da1bcbc><div data-v-5da1bcbc> 해양환경 보전을 위한 활동은 가정, 학교 어디서든 배울 수 있습니다. </div><div data-v-5da1bcbc><span class=\"strong\" data-v-5da1bcbc>가플지우 아카데미</span>를 통해 우리 바다를 위한 여러분의 실천을 쌓아주세요. </div></div><div class=\"board-desc d-block d-sm-none\" data-v-5da1bcbc><div data-v-5da1bcbc> 해양환경 보전을 위한 활동은 </div><div data-v-5da1bcbc> 가정, 학교 어디서든 배울 수 있습니다. </div><div data-v-5da1bcbc><span class=\"strong\" data-v-5da1bcbc>가플지우 아카데미</span>를 통해 우리 바다를 위한 </div><div data-v-5da1bcbc> 여러분의 실천을 쌓아주세요. </div></div><img src=\"" + _imports_2 + "\" class=\"banner\" data-v-5da1bcbc>", 4)
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "strong" }, "가플지우 아카데미 ", -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("바로가기 ")
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"line\" data-v-5da1bcbc></div><div class=\"board-title\" data-v-5da1bcbc> 오프라인 </div><div class=\"board-desc board-desc-2\" data-v-5da1bcbc><div data-v-5da1bcbc> 오프라인에서 만나보는 해양환경버스! </div><div class=\"strong\" data-v-5da1bcbc> &lt;찾아가는 해양환경 이동교실&gt; </div></div><div class=\"banner-box\" data-v-5da1bcbc><img src=\"" + _imports_3 + "\" class=\"image\" data-v-5da1bcbc><img src=\"" + _imports_4 + "\" class=\"image\" data-v-5da1bcbc><img src=\"" + _imports_5 + "\" class=\"image\" data-v-5da1bcbc></div>", 4)

import EmartBtn from './emart-btn.vue';
  import { IEmartProgram } from '../type';

  export interface IProps {
    program: IEmartProgram
  }
export default /*#__PURE__*/_defineComponent({
  props: {
    program: null
  },
  setup(__props: any) {

const props = __props as {
    program: IEmartProgram
  }

  ;

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createTextVNode(_toDisplayString(props.program.custom_key?.configs?.month_count?.value) + "월의 ", 1),
        _createElementVNode("div", null, "아카데미 수료자 " + _toDisplayString(__props.program.custom_key?.user_configs?.academy_graduate_count?.value) + "명", 1)
      ]),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(EmartBtn, {
          to: { name: 'emart.academy', params: { id: props.program.id } },
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _hoisted_13,
            _hoisted_14
          ]),
          _: 1
        }, 8, ["to"]),
        _hoisted_15,
        _createVNode(EmartBtn, {
          class: "emart-btn2",
          text: "자세히 알아보기",
          target: "_blank",
          href: "https://blog.naver.com/merti_center/221674733129"
        })
      ])
    ])
  ]))
}
}

})